<div class="d-flex ps-5 flex-column">
  <app-utility-header
    [title]="'SIDENAV.PROFILE'"
    [utilityName]="id ? editUtilityName : undefined"
    (backButtonClicked)="onBackButtonClicked()"
  ></app-utility-header>

  <div class="toggle-container data-model-customization-toggle">
    <div
      class="toggle-button"
      *ngFor="let tab of tabs"
      (click)="selectTab(tab)"
      [ngClass]="{ active: selectedTab === tab, 'has-errors': submitted && hasErrorsForTab(tab.key), 'is-valid': submitted && !hasErrorsForTab(tab.key) }"
    >
      {{ tab.label | translate }}
    </div>
  </div>
</div>
<div class="divider"></div>

<div *ngIf="submitted && hasErrorsForTab(selectedTab.key)" class="form-error-banner">
  {{ selectedTab.key === 'modal-configuration' ? 'Please enable at least one toggle!' : 'Please fill in all mandatory fields before saving.' }}
</div>

<div class="section">
  <div class="section-header">
    <span class="title">
      {{ this.selectedTab.label | translate }}
    </span>
    <div class="d-flex gap-2">
      <button
        *ngIf="selectedTab.key === 'validation-rules'"
        class="btn btn-secondary"
        data-bs-toggle="modal"
        data-bs-target="#validationRuleModal"
        (click)="openNewValidationRule()"
      >
        Add New
      </button>
      <button
        *ngIf="selectedTab.key === 'configuration-generation'"
        class="btn btn-secondary"
        [class.disabled]="selectedTab.key === 'configuration-generation' && !isAddselectedConfigurationGenerationEnabled"
        data-bs-toggle="modal"
        data-bs-target="#configurationGenerationModal"
        (click)="openselectedConfigurationGeneration()"
      >
        Add New
      </button>
      <button
        *ngIf="selectedTab.position < tabs.length - 1"
        class="btn btn-primary"
        (click)="continue(selectedTab.position + 1)"
      >
        {{ 'COMMON.CONTINUE' | translate }}
      </button>

      <button
        *ngIf="selectedTab.position === tabs.length - 1"
        class="btn btn-success"
        (click)="saveUtility()"
      >
        {{ "COMMON.SAVE" | translate }}
      </button>
    </div>
  </div>
  <div class="section-body" [ngClass]="{ 'pb-0': selectedTab.key === 'active-directory' && !utility.activeDirectoryConfiguration?.isEnabled }">
    <div class="subtitle-row">
      <span class="subtitle">
        {{ this.selectedTab.label | translate }}
      </span>
      <div *ngIf="selectedTab.key === 'electrical-address'" class="code-pattern-toggle-container">
        <label class="toggle-switch">
          <input 
            type="checkbox" 
            [checked]="utility.defaultCaimsCodePatterns"
            (change)="onCodePatternsToggle($event)"
          />
          <span class="toggle-slider"></span>
        </label>
      </div>
      <div *ngIf="selectedTab.key === 'active-directory'" class="code-pattern-toggle-container m-0">
        <label class="toggle-switch">
          <input 
            type="checkbox" 
            [checked]="utility.activeDirectoryConfiguration?.isEnabled"
            (change)="toggleActiveDirectory()"
          />
          <span class="toggle-slider"></span>
        </label>
      </div>
    </div>
    <div class="section-content" [ngClass]="{ 'section-content-invalid': submitted && selectedTab.key === 'modal-configuration' && !validateModalConfiguration(), 
    'd-none': selectedTab.key === 'active-directory' && !utility.activeDirectoryConfiguration?.isEnabled }">
      <div
        *ngIf="selectedTab.key === 'utility-info'"
        [ngTemplateOutlet]="utilityInfo"
      ></div>
      <div
        *ngIf="selectedTab.key === 'modal-configuration'"
        [ngTemplateOutlet]="modalConfiguration"
      ></div>
      <div
        *ngIf="selectedTab.key === 'translator'"
        [ngTemplateOutlet]="translator"
      ></div>
      <div
        *ngIf="selectedTab.key === 'configuration-generation'"
        [ngTemplateOutlet]="configurationGeneration"
      ></div>
      <div
        *ngIf="selectedTab.key === 'validation-rules'"
        [ngTemplateOutlet]="validationRules"
      ></div>
      <div
        *ngIf="selectedTab.key === 'electrical-address'"
        [ngTemplateOutlet]="electricalAddress"
      ></div>
      <div
        *ngIf="selectedTab.key === 'contact-person'"
        [ngTemplateOutlet]="contactPerson"
      ></div>
      <div
        *ngIf="selectedTab.key === 'new-connection'"
        [ngTemplateOutlet]="newConnectionConsent"
      ></div>
      <div
        *ngIf="selectedTab.key === 'bank-account'"
        [ngTemplateOutlet]="bankAccountInformation"
      ></div>
      <div
        *ngIf="selectedTab.key === 'active-directory' && utility.activeDirectoryConfiguration?.isEnabled"
        [ngTemplateOutlet]="activeDirectory"
      ></div>
      <div
        *ngIf="selectedTab.key === 'email-sender'"
        [ngTemplateOutlet]="emailSender"
      ></div>
    </div>
  </div>
  <div *ngIf="selectedTab.key === 'electrical-address'" class="section-body cin-section-body">
    <div class="subtitle-row">
      <span class="subtitle">CIN</span>
      <div class="code-pattern-toggle-container">
        <label class="toggle-switch">
          <input
            type="checkbox"
            [checked]="!utility.defaultCaimsCodePatterns"
            (change)="onCinPatternsToggle($event)"
          />
          <span class="toggle-slider"></span>
        </label>
      </div>
    </div>
    <div class="section-content">
      <div [ngTemplateOutlet]="electricalAddressCIN"></div>
    </div>
  </div>
</div>

<ng-template #utilityInfo>
  <div class="text-input">
    <span>{{ "CRUD.NAME" | translate }} <span class="required-asterisk">*</span></span>
    <label>
      <input
        type="text"
        [(ngModel)]="utility.name"
        [placeholder]="'COMMON.PLACEHOLDERS.UTILITY_NAME' | translate"
        [ngClass]="{ 'is-invalid': submitted && !utility.name }"
      />
    </label>
  </div>
  <div class="text-input">
    <span>{{ "UTILITY_MANAGEMENT.ACRONYM" | translate }} <span class="required-asterisk">*</span></span>
    <label>
      <input
        type="text"
        disabled="{{ id != null && id != 0 }}"
        [(ngModel)]="utility.acronym"
        [placeholder]="'COMMON.PLACEHOLDERS.UTILITY_ACRONYM' | translate"
        [ngClass]="{ 'is-invalid': submitted && !utility.acronym }"
      />
    </label>
  </div>
  <div class="text-input" (click)="triggerFileInput()">
    <span>{{ "UTILITY_MANAGEMENT.UTILITY_LOGO" | translate }} <span class="required-asterisk">*</span></span>

    <div
      class="upload-file-area"
      appDragAndDrop
      (fileDropped)="onFileDropped($event)"
      [ngClass]="{ 'is-invalid': submitted && !hasImage }"
    >
      <ng-template #image>
        <div class="uploaded-image-wrapper">
          <img
            [src]="utility.imageUrl || imageSrc"
            alt="Uploaded image"
            class="uploaded-image"
          />

          <button class="remove-image" (click)="removeImage($event)">×</button>
        </div>
      </ng-template>

      <div *ngIf="!hasImage; else image" class="upload-content">
        <input
          type="file"
          #utilityImage
          style="display: none"
          accept="image/png, image/jpg, image/jpeg"
          (change)="fileBrowserHandler($event)"
        />

        <div class="image-wrapper">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 15.9861C11.4477 15.9861 11 15.5384 11 14.9861V7.82854L7.75748 11.0711L6.34326 9.65685L12.0001 4L17.657 9.65685L16.2428 11.0711L13 7.82831V14.9861C13 15.5384 12.5523 15.9861 12 15.9861ZM6 14H4V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V14H18V18H6V14Z"
              fill="black"
            />
          </svg>
        </div>

        <div class="upload-title-outer">
          <p
            class="upload-title"
            [innerHTML]="'UTILITY_MANAGEMENT.UPLOAD_FILE_TITLE' | translate"
          ></p>
        </div>
      </div>
    </div>
  </div>
  <div class="text-input">
    <span>{{ "COMMON.COLOR" | translate }} <span class="required-asterisk">*</span></span>
    <label>
      <input
        type="text"
        [disabled]="true"
        [placeholder]="'#FFFFFF' | translate"
        [(ngModel)]="utility.colorCode"
        [ngClass]="{ 'is-invalid': submitted && !utility.colorCode }"
      />
    </label>
    <div class="color-palete-container">
      <div class="color-palete d-flex">
        <div
          class="color-circle"
          *ngFor="let colorCircle of circleColors; let i = index"
          [style.background-color]="circleColors[i]"
          (click)="selectColorCircle(colorCircle, i)"
        >
          <svg
            *ngIf="utility.colorCode == colorCircle"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            width="16"
            height="16"
            fill="none"
          >
            <path
              d="M20 52 L40 72 L80 28"
              stroke="#ffffff"
              stroke-width="14"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <button
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#colorModal"
        >
          {{ "NETWORK_ASSET.NODE.MORE" | translate }}
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="id == null" class="text-input">
    <span>{{ "UTILITY_MANAGEMENT.COPY_CONFIGURATION" | translate }}</span>
    <label>
      <select
        [(ngModel)]="utility.utilityIdCopyFrom"
        name="utility-copy-select"
        class="styled-select"
      >
        <option [ngValue]="null">
          {{ "UTILITY_MANAGEMENT.UTILITY_COPY" | translate }}
        </option>
        <option *ngFor="let u of utilityList" [ngValue]="u.key">
          {{ u.value }}
        </option>
      </select>
    </label>
  </div>
  <div class="text-input">
    <span>{{ "COMMON.COUNTRY" | translate }} <span class="required-asterisk">*</span></span>
    <label>
      <select
        [(ngModel)]="utility.country"
        name="country-select"
        required
        class="styled-select"
        (change)="selectCountry($event)"
        [ngClass]="{ 'is-invalid': submitted && !utility.country }"
      >
        <option value="" disabled>{{ "COMMON.COUNTRY" | translate }}</option>
        <option *ngFor="let c of countryList" [value]="c.code">
          {{ c.text }}
        </option>
      </select>
    </label>
  </div>
  <div class="text-input">
    <span>{{ "COMMON.LANGUAGE" | translate }} <span class="required-asterisk">*</span></span>
    <label>
      <select
        [(ngModel)]="utility.language"
        name="language-select"
        required
        class="styled-select"
        (change)="selectLanguage($event)"
        [ngClass]="{ 'is-invalid': submitted && !utility.language }"
      >
        <option value="" disabled>{{ "COMMON.LANGUAGE" | translate }}</option>
        <option *ngFor="let l of languageList" [value]="l.text">
          {{ l.text }}
        </option>
      </select>
    </label>
  </div>
  <div class="text-input">
    <span>{{ "COMMON.CURRENCY" | translate }} <span class="required-asterisk">*</span></span>
    <label>
      <select
        [(ngModel)]="utility.currency"
        name="currency-select"
        required
        class="styled-select"
        (change)="selectCurrency($event)"
        [ngClass]="{ 'is-invalid': submitted && !utility.currency }"
      >
        <option value="" disabled>{{ "COMMON.CURRENCY" | translate }}</option>
        <option *ngFor="let c of currencyList" [value]="c.code">
          {{ c.text }}
        </option>
      </select>
    </label>
  </div>
  <div class="text-input row flex-row">
    <span>Limit assigned areas to mobile users<span class="required-asterisk">*</span></span>
    <div class="btn-group mt-4 col-6">
      <button type="button" class="btn" [class.btn-primary]="!isSelectedAreasForMobileLimited"
        [class.btn-outline-primary]="isSelectedAreasForMobileLimited" (click)="isSelectedAreasForMobileLimited = false">
        Unlimited
      </button>
  
      <button type="button" class="btn" [class.btn-primary]="isSelectedAreasForMobileLimited"
        [class.btn-outline-primary]="!isSelectedAreasForMobileLimited" (click)="isSelectedAreasForMobileLimited = true">
        Limited
      </button>
    </div>
    <div class="mt-4 col-6" *ngIf="isSelectedAreasForMobileLimited">
      <input type="number" class="form-control limit-input" name="maximumSelectedAreasForMobile"
        [(ngModel)]="maximumSelectedAreasForMobile" (blur)="validateLimit()" min="1" placeholder="Enter limit" />
    </div>
  </div>
  <div class="text-input" *ngIf=" id == null || id == 0 ">
    <span>{{ "UTILITY_MANAGEMENT.COPY_CONFIGURATION" | translate }}</span>
    <label>
      <select
        [(ngModel)]="utility.utilityIdCopyFrom"
        name="utility-copy-select-2"
        class="styled-select"
      >
        <option [ngValue]="null">
          {{ "UTILITY_MANAGEMENT.UTILITY_COPY" | translate }}
        </option>
        <option *ngFor="let u of utilityList" [ngValue]="u.key">
          {{ u.value }}
        </option>
      </select>
    </label>
  </div>
</ng-template>

<ng-template #modalConfiguration>
  <div>
    <!-- Asset Configuration -->
    <div class="outer-accordion" ngbAccordion #accordion="ngbAccordion">
      <div
        ngbAccordionItem
        ngbAccordionItem="accordionItemAssets"
        #accordionItemAssets="ngbAccordionItem"
        [collapsed]="true"
        [ngClass]="{
          'no-border': accordionItemAssets.collapsed,
          'accordion-item-settings': !accordionItemAssets.collapsed
        }"
      >
        <div ngbAccordionToggle class="accordion-header">
          <app-toggle-field
            [fieldName]="'SIDENAV.ASSETS'"
            [isExpandable]="true"
            [collapsed]="accordionItemAssets.collapsed"
            [toggleVisible]="false"
          >
          </app-toggle-field>
        </div>

        <div ngbAccordionCollapse>
          <div class="accordion-body">
            <app-toggle-field
              class="inner-toggle"
              [fieldName]="'HEADER_TITLE.MAP'"
              [checked]="isChecked([Configuration.Map])"
              (toggleChange)="onChange([Configuration.Map], $event)"
            ></app-toggle-field>
            <app-toggle-field
              class="inner-toggle"
              [fieldName]="'MAIN_SIDEBAR.AI'"
              [checked]="isChecked([Configuration.AIDroneMap])"
              (toggleChange)="onChange([Configuration.AIDroneMap], $event)"
            >
            </app-toggle-field>
            <app-toggle-field
              class="inner-toggle"
              [fieldName]="'MAIN_SIDEBAR.DETAILS_SIDEBAR.ASSET_LIST.INJECTION_SUBSTATIONS'"
              [checked]="isChecked([Configuration.InjectionSubstation])"
              (toggleChange)="onChange([Configuration.InjectionSubstation], $event)"
            >
            </app-toggle-field>
            <app-toggle-field
              class="inner-toggle"
              [fieldName]="'AI.FEEDERS'"
              [checked]="isChecked([Configuration.Feeders])"
              (toggleChange)="onChange([Configuration.Feeders], $event)"
            ></app-toggle-field>
            <app-toggle-field
              class="inner-toggle"
              [fieldName]="'UTILITY_MANAGEMENT.FEEDER_BANDS'"
              [checked]="isChecked([Configuration.FeederBands])"
              (toggleChange)="onChange([Configuration.FeederBands], $event)"
            ></app-toggle-field>
            <app-toggle-field
              class="inner-toggle"
              [fieldName]="'MAIN_SIDEBAR.DETAILS_SIDEBAR.ASSET_LIST.DISTRIBUTION_SUBSTATIONS'"
              [checked]="isChecked([Configuration.DTs])"
              (toggleChange)="onChange([Configuration.DTs], $event)"
            ></app-toggle-field>
            <app-toggle-field
              class="inner-toggle"
              [fieldName]="'COMMON.RMU'"
              [checked]="isChecked([Configuration.Rmus])"
              (toggleChange)="onChange([Configuration.Rmus], $event)"
            ></app-toggle-field>
            <app-toggle-field
              class="inner-toggle"
              [fieldName]="'MAIN_SIDEBAR.DETAILS_SIDEBAR.ASSET_LIST.MV_POLES'"
              [checked]="isChecked([Configuration.MVPoles])"
              (toggleChange)="onChange([Configuration.MVPoles], $event)"
            >
            </app-toggle-field>
            <app-toggle-field
              class="inner-toggle"
              [fieldName]="'SIDENAV.LT_POLES'"
              [checked]="isChecked([Configuration.Poles])"
              (toggleChange)="onChange([Configuration.Poles], $event)"
            >
            </app-toggle-field>
            <app-toggle-field
              class="inner-toggle"
              [fieldName]="'SIDENAV.BUILDINGS'"
              [checked]="isChecked([Configuration.Buildings])"
              (toggleChange)="onChange([Configuration.Buildings], $event)"
            >
            </app-toggle-field>
            <app-toggle-field
              [fieldName]="'SIDENAV.METERS'"
              class="inner-toggle"
              [checked]="isChecked([Configuration.Meters])"
              (toggleChange)="onChange([Configuration.Meters], $event)"
            >
            </app-toggle-field>
            <app-toggle-field
              [fieldName]="'SIDENAV.NEW_SERVICE'"
              class="inner-toggle"
              [checked]="isChecked([Configuration.NewService])"
              (toggleChange)="onChange([Configuration.NewService], $event)"
            >
            </app-toggle-field>
            <div class="auto-expanded-toggle-field inner-toggle">
              <div class="toggle-field-container toggle-group">
                <label>{{ 'SIDENAV.CUSTOMERS' | translate }}</label>
                <!-- <label class="switch">
                  <input type="checkbox" [checked]="true" />
                  <span class="slider"></span>
                </label> -->
              </div>
              <div class="accordion-body non-collapsible-accordion-items">
                <div class="checkbox-row">
                  <label class="checkbox-item">
                    <input
                      type="checkbox"
                      [checked]="isChecked([Configuration.CustomerManagement])"
                      (change)="
                        onChange([Configuration.CustomerManagement], $event)
                      "
                    />
                    <span>{{ 'DATA_MODEL_CUSTOMIZATION.CUSTOMER_MANAGEMENT' | translate }}</span>
                  </label>

                  <label class="checkbox-item">
                    <input
                      type="checkbox"
                    />
                    <span>{{ 'COMMON.PAYMENT_AND_VEND' | translate }}</span>
                  </label>

                  <label class="checkbox-item">
                    <input
                      type="checkbox"
                      [checked]="isChecked([Configuration.AccountCreation])"
                      (change)="
                        onChange([Configuration.AccountCreation], $event)
                      "
                    />
                    <span>{{ 'COMMON.ACCOUNT_CREATION' | translate }}</span>
                  </label>

                  <label class="checkbox-item">
                    <input
                      type="checkbox"
                      [checked]="isChecked([Configuration.EnergySource])"
                      (change)="onChange([Configuration.EnergySource], $event)"
                    />
                    <span>{{ 'COMMON.ENERGY_SOURCE' | translate }}</span>
                  </label>
                </div>
              </div>
            </div>
          <app-toggle-field
              [fieldName]="'SIDENAV.GALLERY_ACCESS'"
              class="inner-toggle"
              [checked]="isChecked([Configuration.GalleryAccessAssets])"
              (toggleChange)="onChange([Configuration.GalleryAccessAssets], $event)"
            >
          </app-toggle-field>
          <app-toggle-field
              [fieldName]="'SIDENAV.AI_WIDGET'"
              class="inner-toggle"
              [checked]="isChecked([Configuration.AiWidget])"
              (toggleChange)="onChange([Configuration.AiWidget], $event)"
            >
          </app-toggle-field>
          </div>
        </div>
      </div>
    </div>

    <!-- Operations Configuration -->
    <div class="outer-accordion" ngbAccordion #accordion="ngbAccordion">
      <div
        ngbAccordionItem
        ngbAccordionItem="accordionItemOperations"
        #accordionItemOperations="ngbAccordionItem"
        [collapsed]="true"
        [ngClass]="{
          'no-border': accordionItemOperations.collapsed,
          'accordion-item-settings': !accordionItemOperations.collapsed
        }"
      >
        <div ngbAccordionToggle class="accordion-header">
          <app-toggle-field
            [fieldName]="'MAIN_SIDEBAR.OPERATIONS'"
            [isExpandable]="true"
            [collapsed]="accordionItemOperations.collapsed"
            [toggleVisible]="false"
          ></app-toggle-field>
        </div>

        <div ngbAccordionCollapse>
          <div class="accordion-body">
            <app-toggle-field
              [fieldName]="'MAIN_SIDEBAR.DETAILS_SIDEBAR.OPERATIONS.SURVEYS'"
              class="inner-toggle"
              [checked]="isChecked([Configuration.Survey])"
              (toggleChange)="onChange([Configuration.Survey], $event)"
            >
            </app-toggle-field>
            <app-toggle-field
              [fieldName]="'ROLE_MANAGEMENT.CUSTOMER_INSTALLATION'"
              class="inner-toggle"
              [checked]="isChecked([Configuration.Installation])"
              (toggleChange)="onChange([Configuration.Installation], $event)"
            >
            </app-toggle-field>
            <app-toggle-field
              [fieldName]="'MAIN_SIDEBAR.DETAILS_SIDEBAR.OPERATIONS.DT_METER_INSTALLATION'"
              class="inner-toggle"
              [checked]="isChecked([Configuration.DtMeterInstallation])"
              (toggleChange)="onChange([Configuration.DtMeterInstallation], $event)"
            >
            </app-toggle-field>
            <app-toggle-field
              [fieldName]="'SIDENAV.ONLINE_METER_NUMBER_SCAN'"
              class="inner-toggle"
              [checked]="isChecked([Configuration.OnlineMeterNumberScan])"
              (toggleChange)="onChange([Configuration.OnlineMeterNumberScan], $event)"
            >
            </app-toggle-field>
            <div class="auto-expanded-toggle-field inner-toggle">
              <div class="toggle-field-container toggle-group">
                <label>{{ 'COMMON.METER_VALIDATION' | translate}}</label>
                <!-- <label class="switch">
                  <input type="checkbox" [checked]="true" />
                  <span class="slider"></span>
                </label> -->
              </div>
              <div class="accordion-body non-collapsible-accordion-items">
                <div class="description">{{'CUSTOMER_METER_VALIDATION.TITLE' | translate}}</div>
                <div class="checkbox-row">
                  <label class="checkbox-item">
                    <input
                      type="checkbox"
                      [checked]="
                        isChecked([Configuration.MeterValidationTamper])
                      "
                      (change)="
                        onChange([Configuration.MeterValidationTamper], $event)
                      "
                    />
                    <span>{{'CUSTOMER_METER_VALIDATION.TAMPER' | translate}}</span>
                  </label>

                  <label class="checkbox-item">
                    <input
                      type="checkbox"
                      [checked]="isChecked([Configuration.DtConfirmation])"
                      (change)="
                        onChange([Configuration.DtConfirmation], $event)
                      "
                    />
                    <span>{{'CUSTOMER_METER_VALIDATION.DT_CONFIRMATION' | translate}}</span>
                  </label>

                  <label class="checkbox-item">
                    <input
                      type="checkbox"
                      [checked]="isChecked([Configuration.EnergySource])"
                      (change)="onChange([Configuration.EnergySource], $event)"
                    />
                    <span>{{ 'CUSTOMER_METER_VALIDATION.ENERGY_SOURCE' | translate}}</span>
                  </label>
                </div>
              </div>
            </div>

            <app-toggle-field
              [fieldName]="'ROLE_MANAGEMENT.WORK_ORDER'"
              [checked]="isChecked([Configuration.WorkOrder])"
              (toggleChange)="onChange([Configuration.WorkOrder], $event)"
            >
            </app-toggle-field>
          <br/>
            <app-toggle-field
              [fieldName]="'ROLE_MANAGEMENT.CUSTOMER_INFORMATION_EDIT'"
              [checked]="isChecked([Configuration.CustomerInformationEdit])"
              (toggleChange)="onChange([Configuration.CustomerInformationEdit], $event)"
            >
            </app-toggle-field>
          <br/> 
          <app-toggle-field
              [fieldName]="'SIDENAV.GALLERY_ACCESS'"              
              [checked]="isChecked([Configuration.GalleryAccessOperations])"
              (toggleChange)="onChange([Configuration.GalleryAccessOperations], $event)"
            >
          </app-toggle-field>
          <br/>
            <app-toggle-field
              class="inner-toggle"
              [fieldName]="'SIDENAV.SETTLEMENT'"
              [checked]="isChecked([Configuration.Settlement])"
              (toggleChange)="onChange([Configuration.Settlement], $event)"
            >
            </app-toggle-field>
          </div>
        </div>
      </div>
    </div>

    <!-- Meter Management Configuration -->
    <div class="outer-accordion" ngbAccordion #accordion="ngbAccordion">
      <div
        ngbAccordionItem
        ngbAccordionItem="accordionItemMeterManagement"
        #accordionItemMeterManagement="ngbAccordionItem"
        [collapsed]="true"
        [ngClass]="{
          'no-border': accordionItemMeterManagement.collapsed,
          'accordion-item-settings': !accordionItemMeterManagement.collapsed
        }"
      >
        <div ngbAccordionToggle class="accordion-header">
          <app-toggle-field
            [fieldName]="'MAIN_SIDEBAR.METER_MANAGEMENT'"
            [isExpandable]="true"
            [collapsed]="accordionItemMeterManagement.collapsed"
            [toggleVisible]="false"
          ></app-toggle-field>
        </div>

        <div ngbAccordionCollapse>
          <div class="accordion-body">
            <app-toggle-field
              [fieldName]="'MAIN_SIDEBAR.DETAILS_SIDEBAR.METER_MANAGEMENT.CUSTOMERS'"
              class="inner-toggle"
              [isExpandable]="false"
              [checked]="isChecked([Configuration.MeterCustomers])"
              (toggleChange)="onChange([Configuration.MeterCustomers], $event)"
            >
            </app-toggle-field>
            <app-toggle-field
              [fieldName]="'MAIN_SIDEBAR.DETAILS_SIDEBAR.METER_MANAGEMENT.ASSETS'"
              class="inner-toggle"
              [isExpandable]="false"
              [checked]="isChecked([Configuration.MeterAssets])"
              (toggleChange)="onChange([Configuration.MeterAssets], $event)"
            >
            </app-toggle-field>
            <app-toggle-field
              [fieldName]="'MAIN_SIDEBAR.DETAILS_SIDEBAR.METER_MANAGEMENT.METER_APPROVAL_AND_REPAYMENT'"
              class="inner-toggle"
              [isExpandable]="false"
              [checked]="isChecked([Configuration.MeterApprovalAndRepayment])"
              (toggleChange)="onChange([Configuration.MeterApprovalAndRepayment], $event)"
            >
            </app-toggle-field>
            <app-toggle-field
              [fieldName]="'MAIN_SIDEBAR.DETAILS_SIDEBAR.METER_MANAGEMENT.CTVT'"
              class="inner-toggle"
              [isExpandable]="false"
              [checked]="isChecked([Configuration.MeterCtvt])"
              (toggleChange)="onChange([Configuration.MeterCtvt], $event)"
            >
            </app-toggle-field>
          </div>
        </div>
      </div>
    </div>

    <!-- Readings Configuration -->
    <div class="outer-accordion" ngbAccordion #accordion="ngbAccordion">
      <div
        ngbAccordionItem
        ngbAccordionItem="accordionItemReadings"
        #accordionItemReadings="ngbAccordionItem"
        [collapsed]="true"
        [ngClass]="{
          'no-border': accordionItemReadings.collapsed,
          'accordion-item-settings': !accordionItemReadings.collapsed
        }"
      >
        <div ngbAccordionToggle class="accordion-header">
          <app-toggle-field
            [fieldName]="'SIDENAV.READINGS'"
            [isExpandable]="true"
            [collapsed]="accordionItemReadings.collapsed"
            [toggleVisible]="false"
          ></app-toggle-field>
        </div>

        <div ngbAccordionCollapse>
          <div class="accordion-body">
            <app-toggle-field
              [fieldName]="'MAIN_SIDEBAR.DETAILS_SIDEBAR.READINGS.CUSTOMER_METER_READING'"
              class="inner-toggle"
              [isExpandable]="false"
              [checked]="isChecked([Configuration.Readings])"
              (toggleChange)="onChange([Configuration.Readings], $event)"
            >
            </app-toggle-field>
            <app-toggle-field
              [fieldName]="'COMMON.BILLING_INTEGRATION'"
              class="inner-toggle"
              [checked]="isChecked([Configuration.StandaloneBillingIntegration])"
              (toggleChange)="
                onChange([Configuration.StandaloneBillingIntegration], $event)
              "
            >
            </app-toggle-field>
          </div>
        </div>
      </div>
    </div>

    <!-- V3 Implementation -->
 <div class="outer-accordion" ngbAccordion #accordion="ngbAccordion">
      <div
        ngbAccordionItem
        ngbAccordionItem="accordionItemV3"
        #accordionItemV3="ngbAccordionItem"
        [collapsed]="true"
        [ngClass]="{
          'no-border': accordionItemV3.collapsed,
          'accordion-item-settings': !accordionItemV3.collapsed
        }"
      >
        <div ngbAccordionToggle class="accordion-header">
          <app-toggle-field
            [fieldName]="'V3 Implementation'"
            [isExpandable]="true"
            [collapsed]="accordionItemV3.collapsed"
            [toggleVisible]="false"
          ></app-toggle-field>
        </div>

        <div ngbAccordionCollapse>
          <div class="accordion-body">
            <app-toggle-field
              [fieldName]="'MAIN_SIDEBAR.AI'"
              class="inner-toggle"
              [isExpandable]="false"
              [checked]="isChecked([Configuration.AIDroneMap])"
              (toggleChange)="onChange([Configuration.AIDroneMap], $event)"
            >
            </app-toggle-field>
            <app-toggle-field
              [fieldName]="'MAIN_SIDEBAR.NETWORK_MODEL_STRUCTURE'"
              class="inner-toggle"
              [checked]="isChecked([Configuration.NetworkModelStructure])"
              (toggleChange)="
                onChange([Configuration.NetworkModelStructure], $event)
              "
            >
            </app-toggle-field>
            <app-toggle-field
              [fieldName]="'MAIN_SIDEBAR.NETWORK_ENTITY_CLASS_INSTANTIATION'"
              class="inner-toggle"
              [checked]="isChecked([Configuration.NetworkEntityClassInstantiation])"
              (toggleChange)="
                onChange([Configuration.NetworkEntityClassInstantiation], $event)
              "
            >
            </app-toggle-field>
            <app-toggle-field
              [fieldName]="'MAIN_SIDEBAR.DATA_MODEL_CUSTOMIZATION'"
              class="inner-toggle"
              [checked]="isChecked([Configuration.DataModelCustomization])"
              (toggleChange)="
                onChange([Configuration.DataModelCustomization], $event)
              "
            >
            </app-toggle-field>
            <app-toggle-field
              [fieldName]="'MAIN_SIDEBAR.CIM_DATA_INTEGRATION'"
              class="inner-toggle"
              [checked]="isChecked([Configuration.CIMDataIntegration])"
              (toggleChange)="
                onChange([Configuration.CIMDataIntegration], $event)
              "
            >
            </app-toggle-field>
          </div>
        </div>
      </div>
    </div>


    <!-- Map Configuration -->
    <div class="map-configuration-section">
      <div class="outer-map-title-div">
        <div class="inner-map-title-div">
          <label>{{ "COMMON.MAP_CONFIGURATION" | translate }}</label>
        </div>
      </div>

      <div class="map-configuration">
        <div>
          <svg
            width="16"
            height="21"
            viewBox="0 0 16 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.55603 19.9973L7.55382 19.9957L7.54858 19.9918L7.53038 19.9783C7.51487 19.9667 7.49268 19.95 7.46425 19.9284C7.40741 19.8851 7.32559 19.822 7.22236 19.7401C7.01598 19.5764 6.72363 19.3374 6.37392 19.0321C5.67555 18.4223 4.74308 17.5433 3.80853 16.4663C1.96419 14.3408 0 11.3169 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 11.3169 14.0358 14.3408 12.1915 16.4663C11.2569 17.5433 10.3245 18.4223 9.62608 19.0321C9.27637 19.3374 8.98402 19.5764 8.77764 19.7401C8.67441 19.822 8.59259 19.8851 8.53575 19.9284C8.50732 19.95 8.48513 19.9667 8.46962 19.9783L8.45142 19.9918L8.44618 19.9957L8.44454 19.9969C8.44454 19.9969 8.44356 19.9976 8 19.3929L8.44356 19.9976L8 20.323L7.55603 19.9973ZM8 19.3929L7.55603 19.9973C7.55603 19.9973 7.55644 19.9976 8 19.3929ZM4.875 8C4.875 6.27411 6.27411 4.875 8 4.875C9.72589 4.875 11.125 6.27411 11.125 8C11.125 9.72589 9.72589 11.125 8 11.125C6.27411 11.125 4.875 9.72589 4.875 8Z"
              fill="#17171A"
            />
          </svg>
          {{ this.utility.mapConfiguration?.latitude | hasValue }},
          {{ this.utility.mapConfiguration?.longitude | hasValue }}
        </div>
        <div>
          <svg
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 9.93852 15.3098 11.7169 14.1628 13.1012L18.0612 16.9996L17.0005 18.0602L13.1023 14.162C11.7178 15.3094 9.93902 16 8 16C3.58172 16 0 12.4183 0 8ZM8.75 7.25V4H7.25V7.25H4V8.75H7.25V12H8.75V8.75H12V7.25H8.75Z"
              fill="#17171A"
            />
          </svg>
          {{ this.utility.mapConfiguration?.zoom | hasValue }}
        </div>
        <button
          class="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#showMap"
        >
          {{'COMMON.CONFIGURE' | translate}}
        </button>

        <h3 class="sub-header">Select a Preffered Map View</h3>
        <div class="permission-options">
          <div class="permission-item">
            <input type="radio" id="map-view-satellite" class="custom-checkbox"
              [checked]="selectedMapTypeId == 1"
              (change)="selectMapType(1)">
            <label for="map-view-satellite" class="permission-label">{{ "Satellite" | translate }}</label>
          </div>
          <div class="permission-item">
            <input type="radio" id="map-view-map" class="custom-checkbox"
              [checked]="selectedMapTypeId == 2"
              (change)="selectMapType(2)">
            <label for="map-view-map" class="permission-label">{{ "Map" | translate }}</label>
          </div>
        </div>

        <h3 class="sub-header">Choose a Map Theme</h3>
        <div class="permission-options">
          <div class="permission-item">
            <input type="radio" id="map-theme-standard" class="custom-checkbox"
              [checked]="selectedMapThemeId == 1"
              (change)="selectMapTheme(1)">
            <label for="map-theme-standard" class="permission-label">{{ "Standard" | translate }}</label>
          </div>
          <div class="permission-item">
            <input type="radio" id="map-theme-retro" class="custom-checkbox"
              [checked]="selectedMapThemeId == 2"
              (change)="selectMapTheme(2)">
            <label for="map-theme-retro" class="permission-label">{{ "Retro" | translate }}</label>
          </div>
          <div class="permission-item">
            <input type="radio" id="map-theme-silver" class="custom-checkbox"
              [checked]="selectedMapThemeId == 3"
              (change)="selectMapTheme(3)">
            <label for="map-theme-silver" class="permission-label">{{ "Silver" | translate }}</label>
          </div>
          <div class="permission-item">
            <input type="radio" id="map-theme-night" class="custom-checkbox"
              [checked]="selectedMapThemeId == 4"
              (change)="selectMapTheme(4)">
            <label for="map-theme-night" class="permission-label">{{ "Night" | translate }}</label>
          </div>
          <div class="permission-item">
            <input type="radio" id="map-theme-aubergine" class="custom-checkbox"
              [checked]="selectedMapThemeId == 5"
              (change)="selectMapTheme(5)">
            <label for="map-theme-aubergine" class="permission-label">{{ "Aubergine" | translate }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #translator>
  <div
    *ngFor="let item of translationKeys"
    class="kv-card"
    data-bs-toggle="modal"
    data-bs-target="#changeTranslation"
  >
    <div class="kv-left">{{ item.key }}</div>
    <div class="kv-right">{{ item.value }}</div>
  </div>
</ng-template>

<ng-template #newConnectionConsent>
  <div class="text-input">
    <span>{{ "UTILITY_MANAGEMENT.REGULATORY_COMMISSION" | translate }}</span>
    <label>
      <input
        type="text"
        [(ngModel)]="utility.kycConsentConfiguration.regulatoryCommission"
        [placeholder]="'UTILITY_MANAGEMENT.REGULATORY_COMMISSION' | translate"
      />
    </label>
  </div>
  <div class="text-input">
    <span>{{ "UTILITY_MANAGEMENT.ELECTRICITY_REFORM" | translate }}</span>
    <label>
      <input
        type="text"
        [(ngModel)]="utility.kycConsentConfiguration.electricityReform"
        [placeholder]="'UTILITY_MANAGEMENT.ELECTRICITY_REFORM' | translate"
      />
    </label>
  </div>
  <div class="text-input">
    <span>{{ "UTILITY_MANAGEMENT.NETWORK_REGULATION" | translate }}</span>
    <label>
      <input
        type="text"
        [(ngModel)]="utility.kycConsentConfiguration.networkRegulation"
        [placeholder]="'UTILITY_MANAGEMENT.NETWORK_REGULATION' | translate"
      />
    </label>
  </div>
  <div class="text-input">
    <span>{{ "UTILITY_MANAGEMENT.ELECTRICITY_MANAGEMENT" | translate }}</span>
    <label>
      <input
        type="text"
        [(ngModel)]="utility.kycConsentConfiguration.electricityManagement"
        [placeholder]="'UTILITY_MANAGEMENT.ELECTRICITY_MANAGEMENT' | translate"
      />
    </label>
  </div>
  <div class="text-input">
    <span>{{ "COMMON.COUNTRY" | translate }}</span>
    <label>
      <input
        type="text"
        [(ngModel)]="utility.kycConsentConfiguration.country"
        [placeholder]="'COMMON.COUNTRY' | translate"
      />
    </label>
  </div>

  <div class="text-input" (click)="triggerServiceFileInput()">
    <span>{{ "UTILITY_MANAGEMENT.SERVICE_LOGO" | translate }} <span class="required-asterisk">*</span></span>

    <div
      class="upload-file-area"
      appDragAndDrop
      (fileDropped)="onServiceFileDropped($event)"
     
    >
      <ng-template #serviceImage>
        <div class="uploaded-image-wrapper">
          <img
            [src]="utility.kycConsentConfiguration.serviceRequestImageUrl || serviceRequestImageUrl"
            alt="Uploaded image"
            class="uploaded-image"
          />

          <button class="remove-image" (click)="removeServiceImage($event)">×</button>
        </div>
      </ng-template>

      <div *ngIf="!hasServiceImage; else serviceImage" class="upload-content">
        <input
          type="file"
          #serviceImageInput
          style="display: none"
          accept="image/png, image/jpg, image/jpeg"
          (change)="serviceFileBrowserHandler($event)"
        />

        <div class="image-wrapper">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 15.9861C11.4477 15.9861 11 15.5384 11 14.9861V7.82854L7.75748 11.0711L6.34326 9.65685L12.0001 4L17.657 9.65685L16.2428 11.0711L13 7.82831V14.9861C13 15.5384 12.5523 15.9861 12 15.9861ZM6 14H4V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V14H18V18H6V14Z"
              fill="black"
            />
          </svg>
        </div>

        <div class="upload-title-outer">
          <p
            class="upload-title"
            [innerHTML]="'UTILITY_MANAGEMENT.UPLOAD_FILE_TITLE' | translate"
          ></p>
        </div>
      </div>
    </div>
  </div>
  <div class="code-pattern-toggle-container m-0 option-toggle">
    <label class="toggle-switch">
          <input 
            type="checkbox" 
            [checked]="utility.kycConsentConfiguration.cookieConsentEnabled"
            (change)="utility.kycConsentConfiguration.cookieConsentEnabled = !utility.kycConsentConfiguration.cookieConsentEnabled"
          />
          <span class="toggle-slider"></span>
        </label>
    <span>{{ "UTILITY_MANAGEMENT.COOKIE_CONSENT_POLICY" | translate }}</span>
  </div>
  

</ng-template>

<ng-template #configurationGeneration>

  <div class="electrical-address-wrapper">
    <div class="electrical-address-header row">
      <div class="col-3">{{ "UTILITY_MANAGEMENT.VALIDATION_RULES.PROPERTY_TYPE" | translate }}</div>
      <div class="col-3">{{ "UTILITY_MANAGEMENT.CONFIGURATION_GENERATION.LENGTH" | translate }}</div>
      <div class="col-3">{{ "UTILITY_MANAGEMENT.CONFIGURATION_GENERATION.FORMAT_TYPE" | translate }}</div>
      <div class="col-2">{{ "UTILITY_MANAGEMENT.VALIDATION_RULES.START_WITH" | translate }}</div>
      <div class="col-1"></div>
    </div>
    <div class="electrical-address-content">
      <div *ngFor="let configuration of utility.configurationGenerations"
           class="row"
           (click)="onRowClick(configuration)">
        <div 
          [attr.data-bs-toggle]="configuration.id === 0 ? 'modal' : null" 
          [attr.data-bs-target]="configuration.id === 0 ? '#configurationGenerationModal' : null" 
          class="col-3"
        >
          <span>{{ getConfigurationGenerationPropertyTypeLabel(configuration.propertyType) }}</span>
        </div>
        <div 
          [attr.data-bs-toggle]="configuration.id === 0 ? 'modal' : null" 
          [attr.data-bs-target]="configuration.id === 0 ? '#configurationGenerationModal' : null" 
          class="col-3">{{ configuration.length | hasValue}}
        </div>
        <div 
          [attr.data-bs-toggle]="configuration.id === 0 ? 'modal' : null" 
          [attr.data-bs-target]="configuration.id === 0 ? '#configurationGenerationModal' : null" 
          class="col-3"
        >
          <span>{{ getFormatTypeLabel(configuration.formatType) }}</span>
        </div>
        <div [attr.data-bs-toggle]="configuration.id === 0 ? 'modal' : null" [attr.data-bs-target]="configuration.id === 0 ? '#configurationGenerationModal' : null" class="col-2">{{ configuration.startsWith | hasValue }}</div>
        <div class="col-1">
          <svg *ngIf="configuration.id !== 0" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#000" class="bi bi-lock" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8 0a4 4 0 0 1 4 4v2.05a2.5 2.5 0 0 1 2 2.45v5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 13.5v-5a2.5 2.5 0 0 1 2-2.45V4a4 4 0 0 1 4-4M4.5 7A1.5 1.5 0 0 0 3 8.5v5A1.5 1.5 0 0 0 4.5 15h7a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 11.5 7zM8 1a3 3 0 0 0-3 3v2h6V4a3 3 0 0 0-3-3"/>
          </svg>
          <svg *ngIf="configuration.id === 0" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-unlock" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M12 0a4 4 0 0 1 4 4v2.5h-1V4a3 3 0 1 0-6 0v2h.5A2.5 2.5 0 0 1 12 8.5v5A2.5 2.5 0 0 1 9.5 16h-7A2.5 2.5 0 0 1 0 13.5v-5A2.5 2.5 0 0 1 2.5 6H8V4a4 4 0 0 1 4-4M2.5 7A1.5 1.5 0 0 0 1 8.5v5A1.5 1.5 0 0 0 2.5 15h7a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 9.5 7z"/>
          </svg>
          <svg (click)="delete($event, configuration); $event.stopImmediatePropagation()" class="delete-config" *ngIf="configuration.id === 0" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.75 5C2.33579 5 2 5.33579 2 5.75C2 6.16421 2.33579 6.5 2.75 6.5V5ZM21.25 6.5C21.6642 6.5 22 6.16421 22 5.75C22 5.33579 21.6642 5 21.25 5V6.5ZM10.5 10.75C10.5 10.3358 10.1642 10 9.75 10C9.33579 10 9 10.3358 9 10.75H10.5ZM9 16.25C9 16.6642 9.33579 17 9.75 17C10.1642 17 10.5 16.6642 10.5 16.25H9ZM15 10.75C15 10.3358 14.6642 10 14.25 10C13.8358 10 13.5 10.3358 13.5 10.75H15ZM13.5 16.25C13.5 16.6642 13.8358 17 14.25 17C14.6642 17 15 16.6642 15 16.25H13.5ZM15.1477 5.93694C15.2509 6.33808 15.6598 6.57957 16.0609 6.47633C16.4621 6.37308 16.7036 5.9642 16.6003 5.56306L15.1477 5.93694ZM4.00156 5.79829L4.82047 18.4914L6.31736 18.3949L5.49844 5.70171L4.00156 5.79829ZM8.56269 22H15.4373V20.5H8.56269V22ZM19.1795 18.4914L19.9984 5.79829L18.5016 5.70171L17.6826 18.3949L19.1795 18.4914ZM19.25 5H4.75V6.5H19.25V5ZM2.75 6.5H4.75V5H2.75V6.5ZM19.25 6.5H21.25V5H19.25V6.5ZM15.4373 22C17.4146 22 19.0522 20.4647 19.1795 18.4914L17.6826 18.3949C17.6063 19.5788 16.6237 20.5 15.4373 20.5V22ZM4.82047 18.4914C4.94777 20.4647 6.58535 22 8.56269 22V20.5C7.37629 20.5 6.39374 19.5788 6.31736 18.3949L4.82047 18.4914ZM9 10.75V16.25H10.5V10.75H9ZM13.5 10.75V16.25H15V10.75H13.5ZM12 3.5C13.5134 3.5 14.7868 4.53504 15.1477 5.93694L16.6003 5.56306C16.0731 3.51451 14.2144 2 12 2V3.5ZM8.85237 5.93694C9.21319 4.53504 10.4867 3.5 12 3.5V2C9.78568 2 7.92697 3.51451 7.39971 5.56306L8.85237 5.93694Z" fill="#17171A" fill-opacity="0.9"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #validationRules>
  
  <div class="electrical-address-wrapper">
    <div class="electrical-address-header row">
      <div class="col-3">{{ "UTILITY_MANAGEMENT.VALIDATION_RULES.PROPERTY_TYPE" | translate }}</div>
      <div class="col-2">Scope</div>
      <div class="col-3">{{ "UTILITY_MANAGEMENT.VALIDATION_RULES.START_WITH" | translate }}</div>
      <div class="col-2">{{ "UTILITY_MANAGEMENT.VALIDATION_RULES.ALPHANUMERIC" | translate }}</div>
      <div class="col-2">{{ "UTILITY_MANAGEMENT.VALIDATION_RULES.REGEX" | translate }}</div>
    </div>
    <div class="electrical-address-content">
      <div *ngFor="let validationRule of utility.validationRules; let i = index" class="row"
        data-bs-toggle="modal"
        data-bs-target="#validationRuleModal"
        (click)="selectValidationRule(validationRule, i)">
        <div class="col-3">{{ getValidationRuleLabel(validationRule.propertyType) }}</div>
        <div class="col-2">{{ getValidationRuleScopeLabel(validationRule) }}</div>
        <div class="col-3">{{ validationRule.startsWith | hasValue }}</div>
        <div class="col-2"><span>{{ validationRule.isAlfaNumeric == true ? ("COMMON.YES" | translate) : ("COMMON.NO" | translate) }}</span></div>
        <div class="col-2"><span>{{ validationRule.regExp != null ? validationRule.regExp : "NA" }}</span></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #electricalAddress>
  
  <div class="electrical-address-wrapper">
    <div class="electrical-address-header row">
      <div class="col-5">{{ "UTILITY_MANAGEMENT.ELECTRICAL_ADDRESS_CONFIG.ASSET_TYPE" | translate }}</div>
      <div class="col-4">{{ "UTILITY_MANAGEMENT.ELECTRICAL_ADDRESS_CONFIG.PATTERN" | translate }}</div>
      <div class="col-3">{{ "UTILITY_MANAGEMENT.ELECTRICAL_ADDRESS_CONFIG.PREFIX" | translate }}</div>
    </div>
    <div class="electrical-address-content">
      <div *ngFor="let codePattern of utility.codePatterns"
           [class.disabled]="!utility.defaultCaimsCodePatterns"
           [class.invalid]="!codePattern.codePatternOption && utility.defaultCaimsCodePatterns"
           class="row"
           data-bs-toggle="modal"
           data-bs-target="#showElectricalAddress"
           (click)="utility.defaultCaimsCodePatterns && selectCodePattern(codePattern)">
        <div class="col-5">{{ codePattern.displayAssetType }}</div>
        <div class="col-4"><span>{{ codePattern.displayPatternOption != '' ? codePattern.displayPatternOption : "NA" }}</span></div>
        <div class="col-3"><span>{{ (codePattern.prefix != undefined && codePattern.prefix != '') ? codePattern.prefix : "NA" }}</span></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #electricalAddressCIN>
  <div class="electrical-address-wrapper">
    <div class="electrical-address-content cin-content" [class.disabled]="utility.defaultCaimsCodePatterns">
      <div *ngFor="let cinAssetType of cinAssetTypes" class="row">
        <div class="col-12">{{ cinAssetType }}</div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #bankAccountInformation>
  <div class="text-input">
    <span>{{ "UTILITY_MANAGEMENT.BANK_ACC_INFO" | translate }}</span>
    <label>
      <input
        type="text"
        [(ngModel)]="utility.bankDetails.bankName"
        [placeholder]="'UTILITY_MANAGEMENT.BANK_NAME' | translate"
      />
    </label>
  </div>
  <div class="text-input">
    <span>{{ "READING.ACCOUNT_NAME" | translate }}</span>
    <label>
      <input
        type="text"
        [(ngModel)]="utility.bankDetails.accountName"
        [placeholder]="'READING.ACCOUNT_NAME' | translate"
      />
    </label>
  </div>
  <div class="text-input">
    <span>{{ "COMMON.BILLING_ACCOUNTS.NUMBER" | translate }}</span>
    <label>
      <input
        type="text"
        [(ngModel)]="utility.bankDetails.accountNumber"
        [placeholder]="'COMMON.BILLING_ACCOUNTS.NUMBER' | translate"
      />
    </label>
  </div>
</ng-template>

<ng-template #contactPerson>
  <div class="text-input">
    <span>{{ "COMMON.USER.FIRST_NAME" | translate }} <span class="required-asterisk">*</span></span>
    <label>
      <input
        type="text"
        [(ngModel)]="utility.contactPerson.firstName"
        [placeholder]="'COMMON.USER.FIRST_NAME' | translate"
        [ngClass]="{ 'is-invalid': submitted && !utility.contactPerson.firstName }"
      />
    </label>
  </div>
  <div class="text-input">
    <span>{{ "COMMON.USER.LAST_NAME" | translate }} <span class="required-asterisk">*</span></span>
    <label>
      <input
        type="text"
        [(ngModel)]="utility.contactPerson.lastName"
        [placeholder]="'COMMON.USER.LAST_NAME' | translate"
        [ngClass]="{ 'is-invalid': submitted && !utility.contactPerson.lastName }"
      />
    </label>
  </div>
  <div class="text-input">
    <span>{{ "COMMON.USER.EMAIL" | translate }} <span class="required-asterisk">*</span></span>
    <label>
      <input
        type="text"
        [(ngModel)]="utility.contactPerson.eMail"
        [placeholder]="'COMMON.USER.EMAIL' | translate"
        [ngClass]="{ 'is-invalid': submitted && !utility.contactPerson.eMail }"
      />
    </label>
  </div>
</ng-template>

<ng-template #activeDirectory>
  <ng-container *ngIf="utility.activeDirectoryConfiguration && utility.activeDirectoryConfiguration.isEnabled">
    <div class="text-input">
      <span>{{ "UTILITY_MANAGEMENT.ACTIVE_DIRECTORY.APPLICATION_ID" | translate }}</span>
      <label>
        <input
          type="text"
          [(ngModel)]="utility.activeDirectoryConfiguration.applicationId"
          [placeholder]="'UTILITY_MANAGEMENT.ACTIVE_DIRECTORY.APPLICATION_ID' | translate"
        />
      </label>
    </div>
    <div class="text-input">
      <span>{{ "UTILITY_MANAGEMENT.ACTIVE_DIRECTORY.OBJECT_ID" | translate }}</span>
      <label>
        <input
          type="text"
          [(ngModel)]="utility.activeDirectoryConfiguration.objectId"
          [placeholder]="'UTILITY_MANAGEMENT.ACTIVE_DIRECTORY.OBJECT_ID' | translate"
        />
      </label>
    </div>
    <div class="text-input">
      <span>{{ "UTILITY_MANAGEMENT.ACTIVE_DIRECTORY.TENANT_ID" | translate }}</span>
      <label>
        <input
          type="text"
          [(ngModel)]="utility.activeDirectoryConfiguration.tenantId"
          [placeholder]="'UTILITY_MANAGEMENT.ACTIVE_DIRECTORY.TENANT_ID' | translate"
        />
      </label>
    </div>
  </ng-container>
  
</ng-template>

<ng-template #emailSender>
    <div class="text-input">
      <span>{{ "UTILITY_MANAGEMENT.EMAIL_SENDER.SENDER_EMAIL_ADDRESS" | translate }}</span>
      <label>
        <input
          type="text"
          [(ngModel)]="utility.senderEmail"
          [placeholder]="'UTILITY_MANAGEMENT.EMAIL_SENDER.SENDER_EMAIL_ADDRESS' | translate"
        />
      </label>
    </div>
    <div class="text-input">
      <span>{{ "UTILITY_MANAGEMENT.EMAIL_SENDER.API_KEY" | translate }}</span>
      <label>
        <input
          type="text"
          [(ngModel)]="utility.sendgridApiKey"
          [placeholder]="'UTILITY_MANAGEMENT.EMAIL_SENDER.API_KEY' | translate"
        />
      </label>
    </div>
</ng-template>

<div
  class="modal modalMap"
  id="showMap"
  tabindex="-1"
  aria-hidden="true"
  data-bs-backdrop="true"
  data-bs-keyboard="true"
>
  <div class="modal-dialog modal-fullscreen">
    <div class="modal-content">
      <div class="modal-body p-0">
        <app-map-configuration
          [longitude]="18.2811944"
          [latitude]="9.1021111"
          [zoom]="4"
          (mapConfigurationSaved)="onMapConfigurationSaved($event)"
        >
        </app-map-configuration>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="colorModal"
  tabindex="-1"
  aria-labelledby="colorModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="colorModalLabel">
          {{ "COMMON.COLOR" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div
        class="modal-body d-flex gap-4 justify-content-center align-items-center"
      >
        <color-sketch
          [color]="utility.colorCode"
          (onChangeComplete)="onColorChange($event)"
        >
        </color-sketch>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-dark" data-bs-dismiss="modal">
          {{ "COMMON.ADD" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="fade modal modal-electrical-address"
  id="configurationGenerationModal"
  tabindex="-1"
  aria-hidden="true"
  data-bs-backdrop="true"
  data-bs-keyboard="true"
>
    <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-0">
        <div class="change-code-pattern-title">
          New Configuration Generation
        </div>
        <div class="change-code-pattern-content">
          <div class="text-input">
            <span>Property Type</span>
            <label>
              <select
                [(ngModel)]="selectedConfigurationGeneration.propertyType"
                (ngModelChange)="onConfigurationGenerationPropertyTypeChange($event)"
                name="validation-rule-property"
                class="styled-select"
              >
                <option value="" disabled>Select property type</option>
                <option [ngValue]="ConfigurationGenerationPropertyType.AccountNumber">AccountNumber</option>
                <option [ngValue]="ConfigurationGenerationPropertyType.Spn">SPN</option>
              </select>
            </label>
          </div>
          <div class="text-input">
            <span>{{ "UTILITY_MANAGEMENT.CONFIGURATION_GENERATION.LENGTH" | translate }}</span>
            <label>
              <input
                type="number"
                [(ngModel)]="selectedConfigurationGeneration.length!"
              />
            </label>
          </div>
          <div class="text-input">
            <span>{{ "UTILITY_MANAGEMENT.CONFIGURATION_GENERATION.FORMAT_TYPE" | translate}}</span>
            <label>
              <select
                [(ngModel)]="selectedConfigurationGeneration.formatType"
                (ngModelChange)="onConfigurationGenerationFormatTypeChange($event)"
                name="validation-rule-property"
                class="styled-select"
              >
                <option value="" disabled>Select format type</option>
                <option [ngValue]="FormatType.Numeric">Numeric</option>
                <option [ngValue]="FormatType.Alphanumeric">Alphanumeric</option>
              </select>
            </label>
          </div>
          <div class="text-input">
            <span>{{ "UTILITY_MANAGEMENT.VALIDATION_RULES.START_WITH" | translate }}</span>
            <label>
              <input
                type="text"
                [(ngModel)]="selectedConfigurationGeneration.startsWith"
              />
            </label>
          </div>
        </div>
        <div class="change-code-pattern-footer">
          <button class="btn btn-secondary" #closeConfigurationGenerationModal data-bs-dismiss="modal" (click)="resetConfigurationGeneration()">{{ "COMMON.CLOSE" | translate }}</button>
          <button class="btn btn-primary" (click)="saveConfigurationGeneration()">{{ "COMMON.SAVE" | translate }}</button>
          <button class="d-none" #closeConfigurationGenerationModal data-bs-dismiss="modal"></button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="fade modal modal-electrical-address"
  id="validationRuleModal"
  tabindex="-1"
  aria-hidden="true"
  data-bs-backdrop="true"
  data-bs-keyboard="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-0">
        <div class="change-code-pattern-title">
          Validation Rule
        </div>
        <div class="change-code-pattern-content">
          <div class="text-input">
            <span>Property Type</span>
            <label>
              <select
                [(ngModel)]="selectedValidationRule.propertyType"
                (ngModelChange)="onValidationRuleTypeChange($event)"
                name="validation-rule-property"
                class="styled-select"
                [disabled]="isEditingValidationRule"
              >
                <option value="" disabled>Select property type</option>
                <option *ngFor="let ruleType of availableValidationRuleTypeOptions" [ngValue]="ruleType.value">
                  {{ ruleType.label }}
                </option>
              </select>
            </label>
          </div>
          <div
            class="text-input"
            *ngIf="activeSpecialConfig as specialConfig"
          >
            <span>{{ specialConfig.fieldLabel }}</span>
            <label>
              <select
                [(ngModel)]="selectedValidationRule.scopeId"
                name="validation-rule-scope"
                class="styled-select"
              >
                <option [ngValue]="null" disabled>{{ specialConfig.placeholder }}</option>
                <option
                  *ngFor="let scopeOption of activeScopeOptions"
                  [ngValue]="scopeOption.id"
                >
                  {{ scopeOption.label }}
                </option>
              </select>
            </label>
          </div>
          <div class="text-input">
            <span>Starts with</span>
            <label>
              <input
                type="text"
                [(ngModel)]="selectedValidationRule.startsWith"
              />
            </label>
          </div>
          <div class="text-input">
            <span>Regular Expression</span>
            <label>
              <input
                type="text"
                [(ngModel)]="selectedValidationRule.regExp"
              />
            </label>
          </div>
          <div class="text-input">
            <span>{{ "UTILITY_MANAGEMENT.VALIDATION_RULES.ALPHANUMERIC" | translate }}</span>
            <label>
              <select
                [(ngModel)]="selectedValidationRule.isAlfaNumeric"
                name="validation-rule-alphanumeric"
                class="styled-select"
              >
                <option [ngValue]="null" disabled>Select...</option>
                <option [ngValue]="true">{{ "COMMON.YES" | translate }}</option>
                <option [ngValue]="false">{{ "COMMON.NO" | translate }}</option>
              </select>
            </label>
          </div>
        </div>
        <div class="change-code-pattern-footer">
          <button class="btn btn-secondary" data-bs-dismiss="modal" (click)="resetValidationRuleModal()">{{ "COMMON.CLOSE" | translate }}</button>
          <button class="btn btn-primary" (click)="saveValidationRule()">{{ "COMMON.SAVE" | translate }}</button>
          <button class="d-none" #closeValidationRuleModal data-bs-dismiss="modal"></button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal modal-electrical-address"
  id="showElectricalAddress"
  tabindex="-1"
  aria-hidden="true"
  data-bs-backdrop="true"
  data-bs-keyboard="true"
  (hide.bs.modal)="clearCodePattern()"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-0">
        <div class="change-code-pattern-title">
          {{ "UTILITY_MANAGEMENT.ELECTRICAL_ADDRESS_CONFIG.CHANGE_CODE_PATTERN.TITLE" | translate }}
        </div>
        <div class="change-code-pattern-content">
          <div class="text-input">
            <span>{{ "UTILITY_MANAGEMENT.ELECTRICAL_ADDRESS_CONFIG.ASSET_TYPE" | translate }}</span>
            <label>
              <input
                type="text"
                [(ngModel)]="selectedCodePattern.displayAssetType"
                [placeholder]=""
                required
                [disabled]="true"
              />
            </label>
          </div>
          <div class="code-pattern-div">
            <label class="code-pattern-label">
              <select
                [(ngModel)]="selectedCodePatternOption"
                name="code-pattern-select"
                required
                class="styled-select"
                (change)="selectPattern($event)"
              >
                <option value="" disabled value="undefined">{{ "UTILITY_MANAGEMENT.ELECTRICAL_ADDRESS_CONFIG.CHANGE_CODE_PATTERN.SELECT_CODE_PATTERN" | translate }}</option>
                <option *ngFor="let pattern of codePatternOptions" [value]="pattern.key">
                {{ pattern.value }}
                </option>
              </select>
            </label>
          </div>
          <div *ngIf="showPrefix" class="text-input">
            <span>{{ "UTILITY_MANAGEMENT.ELECTRICAL_ADDRESS_CONFIG.PREFIX" | translate }}</span>
            <label>
              <input
                type="text"
                [(ngModel)]="selectedCodePattern.prefix"
                [placeholder]=""
                required
              />
            </label>
          </div>
        </div>
        <div class="change-code-pattern-footer">
          <button class="btn btn-secondary" #closeCodePatternModal data-bs-dismiss="modal">{{ "COMMON.CLOSE" | translate }}</button>
          <button class="btn btn-primary" (click)="saveCodePattern()">{{ "COMMON.SAVE" | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
